function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#E5A03E",
  d: "M26 43v13c0 1.1.67 1.42 1.52.69L63 26 26 43z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FCD669",
  d: "M63 26L44.06 56.3a1.68 1.68 0 01-2.59.4L30 47l33-21zm0 0L26 44l-12.21-6.1c-1-.5-.92-1.09.16-1.32L63 26z"
}));

function SvgSubmit(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80
  }, props), _ref);
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI4MHB4IiBoZWlnaHQ9IjgwcHgiPgogIDxnIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+CiAgICA8Zz4KICAgICAgPHBhdGggZmlsbD0iI0U1QTAzRSIgZD0iTTI2IDQzdjEzYzAgMS4xLjY3IDEuNDIgMS41Mi42OUw2MyAyNiAyNiA0M3oiLz4KICAgICAgPHBhdGggZmlsbD0iI0ZDRDY2OSIgZD0iTTYzIDI2TDQ0LjA2IDU2LjNhMS42OCAxLjY4IDAgMCAxLTIuNTkuNEwzMCA0N2wzMy0yMXptMCAwTDI2IDQ0bC0xMi4yMS02LjFjLTEtLjUtLjkyLTEuMDkuMTYtMS4zMkw2MyAyNnoiLz4KICAgIDwvZz4KICA8L2c+Cjwvc3ZnPgo=";
export { SvgSubmit as ReactComponent };